import Action from './Action'
// import './styles/ModalCreateException.css'
import mapboxgl from 'mapbox-gl';
import { useState ,useEffect} from 'react';
import LoadSimple from './LoadSimple';
import InputAdmin from './InputAdmin';
import { useFetch } from '../hooks/useFetch';
import SelectorAdmin from './SelectorAdmin';
import { capitalizeFirstLetter } from '../utils/utils';
import { lang } from './generales/traduction';
const ModalCreateException =({props,closeExeption})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    //   const dataAgencies=useFetch('cassia/exception_agencies','','','GET',server)

    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [agenciaId, setAgenciaId] = useState(props.dataAgencies.data.length!=0?props.dataAgencies.data.data[0].exception_agency_id:1);
    const [ManttoData,setManttoData]=useState({
        exception_agency_id: agenciaId,
            description:"",
            hostid: props.data.hostid,
            created_at: obtenerFechaActualLocal()
    })
    const [excepcion, setExcepcion] = useState('');
    const [addingException, setAddingException] = useState(false);





    function getNameById(id) {
        const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
        return agency ? agency.name : null;
    }
    function getColorById(id) {
      const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
      return agency ? agency.color : null;
    }
    const setTagExcept=(agency_id)=>{
        const coordinates = [props.data.longitude.replace(",", "."),props.data.latitude.replace(",", ".")];
        //  const agency_id = 2
        props.mapAux.setZoom(12);
        props.mapAux.setCenter(coordinates);
        let popup = new mapboxgl.Popup({
          className: (props.mode=="")?'custom-popup-except':'custom-popup-except-white',
          closeButton: false,
          closeOnClick: false
      })
          .setLngLat(coordinates)
              .setHTML(`<div class='cont-except' style='border: 1px solid #ffffff;'>
          
          <div class='valexcept' style='background: ${getColorById(agency_id)}'><div class='txtexcept'  >${getNameById(agency_id)}</div><br><br></div>
              </div>`)
              .addTo(props.mapAux);
        return popup;
    }


    const addException=async(e)=>{
        //console.log('ejecuta la excepcion')
        setAddingException(true)
  
        //   var exceptData={
        //     "exception_agency_id": agenciaId,
        //     "description":excepcion,
        //     "hostid": props.data.hostid,
        //     // "created_at": currentDateTime
        //   }
        
          try {
              const response = await fetch(props.server.url+'/api/v1/cassia/exceptions', {
                method: "POST",
                headers: {
                  "Accept": "application/json",
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                },
                body: JSON.stringify(ManttoData),
              });
              if (response.ok) {
                  //   props.setSearchTerm("")
                  const data = await response.json();
                  //   setCloseEvent(false)
                  //   setExeptionOpen(false);
                  setAddingException(false)
                  props.handleShowPopup(capitalizeFirstLetter(lang[props.languaje]['completado']),capitalizeFirstLetter((lang[props.languaje]['regGenCorr'])),'', true)
                  closeExeption()
                  setTagExcept(ManttoData.exception_agency_id)
                  props.search_problems()
              } else {
                  const data = await response.json();
                  props.handleShowPopup('ERROR!',capitalizeFirstLetter((lang[props.languaje]['regNoGenCorr'])),'Favor de reportar', false)
                  closeExeption()
                  //console.log(data.detail)
                  //   setCloseEvent(false)
                  //   setResponseDetail(data.detail)
                  throw new Error('Error en la solicitud');
              }
          } catch (error) {
              setAddingException(false)
              //console.log(error)
          }
      }



    const changeOption=(option,index)=>{
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['exception_agency_id']:option.value===""?0:(parseInt(option.value))
            }
            
        })
        // setManttoRelation(option.value)
    }


    const handleChange=(e)=>{
        const {name,value}=e.target
        setManttoData((prevState)=>{
            return {
                ...prevState,
                [name]:value
            }
            
        })
    }

    const {exception_agency_id,
        description,
        hostid,
        created_at}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                    {capitalizeFirstLetter(lang[props.languaje]['crearExcepcion'])}
                    </div>
                </div>
                <div className='content-card-modal-gs'>
                                {1==1?
                                // nivelForm===1?
                                    <>
                                    <div className="form-GS-box"> 
                                    
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        <input required name="name"  type="text" value={props.data.eventid} disabled
                                    />
                                        <label className='label-GS'> {'Event ID'}</label>
                                        
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                    {/* <Selector opGeneral={false}  onChangeSelect={setAgenciaId} txtOpGen={''}origen={'mapa'} data={props.dataAgencies.data.data} loading={props.dataAgencies.loading}  titulo='Agencia' props={props}></Selector> */}
                                    <SelectorAdmin placeholder={'Seleccionar agencia...'} opGeneral={false} txtOpGen={''}  opt_de={'0'} origen={'Admin'} data={props.dataAgencies.data.data} loading={props.dataAgencies.loading}  titulo='Agencia' selectFunction={changeOption} index={0}></SelectorAdmin>
                                    {/* <Selector  opGeneral={false} onChangeSelect={setAgenciaId} txtOpGen={''}  opt_de={'0'} origen={'mapa'} data={props.dataAgencies.data.data} loading={props.dataAgencies.data.data}  titulo='Agencia' props={props}></Selector> */}
                                        <label className='label-GS'> {capitalizeFirstLetter(lang[props.languaje]['agencia'])}</label>
                                        
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        {/* <div className='contListIconsAgencys' style={{border:'unset'}}> */}
                                       
                                        <input required name="description"  type="text" value={description} onChange={handleChange} />
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[props.languaje]['notas'])}</label> 
                                       
                                    </div>
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        {/* <div className='contListIconsAgencys' style={{border:'unset'}}> */}
                                        <input required name="created_at"      type="datetime-local" 
                          value={created_at} 
                          onChange={handleChange}  />
                                   
                                            
                                        
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[props.languaje]['fecha'])}</label> 
                                       
                                    </div>
                                    <div className="user-box-admin" style={{height:'20%'}}>
                                        {
                                            (addingException)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                               <Action origen='Azul' titulo={capitalizeFirstLetter(lang[props.languaje]['crear'])} action={addException} disabled={false}/>
                                               <Action origen='Cancelar' titulo={capitalizeFirstLetter(lang[props.languaje]['cancelar'])} action={closeExeption} disabled={false} /></>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>{'Usuario '+(editActive? 'editado':'registrado' )+' correctamente'}</span>:''
                                    }
                                        
                                    </div>
                                </div>
                                    </> 
                                    :''
                                 
                            }
                            </div>
                </div>
        </div>
    )
}

export default ModalCreateException